// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f8bc70e4","513":"22f94432","703":"1b7eb637"}[chunkId] + ".chunk.js";
};